// extracted by mini-css-extract-plugin
module.exports =  {"placeholder":"hP40ERdj94FxLT03RUcy"};